<div [formGroup]="form">
  <p-accordion [multiple]="false" value="0" class="gap-2">
    <!-- Übergabe / Sicherstellende Stelle -->
    <p-accordion-panel value="0">
      <p-accordion-header>
        <span>{{ 'animalAdd.securing.handover.headline' | transloco }}</span>
      </p-accordion-header>
      <p-accordion-content>
        <div class="grid grid-cols-12 gap-2">
          <div class="col-span-12 md:col-span-6">
            <div class="flex items-center gap-2">
              <p-iftalabel class="flex-1">
                <p-select
                  class="w-full"
                  inputId="handoverAuthority"
                  [options]="competentAuthorities"
                  optionLabel="name"
                  formControlName="handoverAuthority"
                  appendTo="body"
                  (onChange)="onHandoverAuthorityChange($event.value)"
                />
                <label for="handoverAuthority">{{ 'animalAdd.securing.handover.authority' | transloco }}</label>
              </p-iftalabel>
              <p-button
                icon="pi pi-plus"
                [text]="true"
                [rounded]="true"
                [raised]="true"
                [pTooltip]="'animalAdd.securing.handover.newAuthority' | transloco"
                tooltipPosition="top"
                (click)="createAuthorityDialogVisible = true"
              />
            </div>
          </div>
          <div class="col-span-12 md:col-span-6">
            <div class="flex items-center gap-2">
              <p-iftalabel class="flex-1">
                <p-select
                  class="w-full"
                  inputId="handoverResponsibleContact"
                  [options]="handoverResponsibleContacts"
                  formControlName="handoverResponsibleContact"
                  appendTo="body"
                >
                  <ng-template #selectedItem let-contact>
                    {{ contactLabel(contact) }}
                  </ng-template>
                  <ng-template #item let-contact>
                    {{ contactLabel(contact) }}
                  </ng-template>
                </p-select>
                <label for="handoverResponsibleContact">{{ 'animalAdd.securing.handover.responsibleContact' | transloco }}</label>
              </p-iftalabel>
              <p-button
                icon="pi pi-plus"
                [text]="true"
                [rounded]="true"
                [raised]="true"
                [disabled]="!form.get('handoverAuthority')?.value"
                [pTooltip]="'animalAdd.securing.handover.newContact' | transloco"
                tooltipPosition="top"
                (click)="openContactDialog()"
              />
            </div>
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <p-datepicker
                formControlName="dateOfReceipt"
                [showIcon]="true"
                [iconDisplay]="'input'"
                [showTime]="true"
                [hourFormat]="'24'"
                dateFormat="dd.mm.yy"
                inputId="securingDateOfReceipt"
                [styleClass]="form.get('dateOfReceipt')?.invalid ? 'datepicker-invalid' : ''"
                appendTo="body"
              />
              <label for="securingDateOfReceipt">{{ 'animalAdd.origin.dateOfReceiptAndTime' | transloco }}</label>
            </p-iftalabel>
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <input pInputText type="text" class="w-full" id="securingLocation" formControlName="originLocation"
                [ngClass]="{ '!border-red-500': form.get('originLocation')?.invalid }" />
              <label for="securingLocation">{{ 'animalAdd.origin.location' | transloco }}</label>
            </p-iftalabel>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>

    <!-- Grund der Sicherstellung -->
    <p-accordion-panel value="1">
      <p-accordion-header>
        <span>{{ 'animalAdd.securing.reasons.headline' | transloco }}</span>
      </p-accordion-header>
      <p-accordion-content>
        <div class="grid grid-cols-12 gap-2">
          <div class="col-span-12">
            <p-iftalabel>
              <p-select class="w-full" id="securingReason" [options]="securingReasonOptions"
                optionLabel="label" optionValue="value" formControlName="securingReason" appendTo="body" />
              <label for="securingReason">{{ 'animalAdd.securing.reasons.label' | transloco }}</label>
            </p-iftalabel>
          </div>
          @if (isOtherReason) {
            <div class="col-span-12">
              <p-iftalabel>
                <input pInputText type="text" class="w-full" id="securingReasonOther" formControlName="securingReasonOther" />
                <label for="securingReasonOther">{{ 'animalAdd.securing.reasons.other' | transloco }}</label>
              </p-iftalabel>
            </div>
          }
        </div>
      </p-accordion-content>
    </p-accordion-panel>

    <!-- Vorfall & Einsatz -->
    <p-accordion-panel value="2">
      <p-accordion-header>
        <span>{{ 'animalAdd.securing.incident.headline' | transloco }}</span>
      </p-accordion-header>
      <p-accordion-content>
        <div class="grid grid-cols-12 gap-2">
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <p-datepicker
                formControlName="operationStartAt"
                [showIcon]="true"
                [iconDisplay]="'input'"
                [showTime]="true"
                [hourFormat]="'24'"
                dateFormat="dd.mm.yy"
                inputId="operationStartAt"
                appendTo="body"
              />
              <label for="operationStartAt">{{ 'animalAdd.securing.incident.operationStartAt' | transloco }}</label>
            </p-iftalabel>
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <p-datepicker
                formControlName="operationEndAt"
                [showIcon]="true"
                [iconDisplay]="'input'"
                [showTime]="true"
                [hourFormat]="'24'"
                dateFormat="dd.mm.yy"
                inputId="operationEndAt"
                appendTo="body"
              />
              <label for="operationEndAt">{{ 'animalAdd.securing.incident.operationEndAt' | transloco }}</label>
            </p-iftalabel>
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <textarea pInputText class="w-full" id="incidentCourse" rows="6" formControlName="incidentCourse"></textarea>
              <label for="incidentCourse">{{ 'animalAdd.securing.incident.course' | transloco }}</label>
            </p-iftalabel>
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <textarea pInputText class="w-full" id="operationDescription" rows="6" formControlName="operationDescription"></textarea>
              <label for="operationDescription">{{ 'animalAdd.securing.incident.operationDescription' | transloco }}</label>
            </p-iftalabel>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>

    <!-- Bissopfer (nur bei Beißvorfall) -->
    @if (isBiteIncident) {
      <p-accordion-panel value="3">
        <p-accordion-header>
          <span>{{ 'animalAdd.securing.biteVictim.headline' | transloco }}</span>
        </p-accordion-header>
        <p-accordion-content>
          <div class="grid grid-cols-12 gap-2">
            <div class="col-span-12 md:col-span-4">
              <p-iftalabel>
                <p-select class="w-full" id="biteVictimType" [options]="biteVictimTypeOptions"
                  optionLabel="label" optionValue="value" formControlName="biteVictimType" appendTo="body" />
                <label for="biteVictimType">{{ 'animalAdd.securing.biteVictim.type' | transloco }}</label>
              </p-iftalabel>
            </div>
            <div class="col-span-12 md:col-span-4">
              <p-iftalabel>
                <p-select class="w-full" id="biteVictimGender" [options]="biteVictimGenderOptions"
                  optionLabel="label" optionValue="value" formControlName="biteVictimGender" appendTo="body" />
                <label for="biteVictimGender">{{ 'animalAdd.securing.biteVictim.gender' | transloco }}</label>
              </p-iftalabel>
            </div>
            <div class="col-span-12 md:col-span-4">
              <p-iftalabel>
                <input pInputText type="number" min="0" class="w-full" id="biteVictimAge" formControlName="biteVictimAge" />
                <label for="biteVictimAge">{{ 'animalAdd.securing.biteVictim.age' | transloco }}</label>
              </p-iftalabel>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    }

    <!-- Haltungsbedingungen & weitere Tiere -->
    <p-accordion-panel value="4">
      <p-accordion-header>
        <span>{{ 'animalAdd.securing.housing.headline' | transloco }}</span>
      </p-accordion-header>
      <p-accordion-content>
        <div class="grid grid-cols-12 gap-2">
          <div class="col-span-12">
            <p-iftalabel>
              <textarea pInputText class="w-full" id="housingConditionsDescription" rows="5"
                formControlName="housingConditionsDescription"></textarea>
              <label for="housingConditionsDescription">{{ 'animalAdd.securing.housing.conditions' | transloco }}</label>
            </p-iftalabel>
          </div>
          <div class="col-span-6 flex items-center gap-2 mt-2">
            <p-checkbox inputId="otherAnimalsLeftOnSite" binary="true" formControlName="otherAnimalsLeftOnSite"></p-checkbox>
            <label for="otherAnimalsLeftOnSite">{{ 'animalAdd.securing.housing.otherAnimalsLeftOnSite' | transloco }}</label>
          </div>
          @if (otherAnimalsLeftOnSite) {
            <div class="col-span-6">
              <p-iftalabel>
                <textarea pInputText class="w-full" id="otherAnimalsDescription" rows="4"
                  formControlName="otherAnimalsDescription"></textarea>
                <label for="otherAnimalsDescription">{{ 'animalAdd.securing.housing.otherAnimalsDescription' | transloco }}</label>
              </p-iftalabel>
            </div>
          }
        </div>
      </p-accordion-content>
    </p-accordion-panel>

    <!-- Gesundheit & Verhalten -->
    <p-accordion-panel value="5">
      <p-accordion-header>
        <span>{{ 'animalAdd.securing.health.headline' | transloco }}</span>
      </p-accordion-header>
      <p-accordion-content>
        <div class="grid grid-cols-12 gap-2">
          <div class="col-span-12 mt-2">
            <app-body-condition-score
              [careCtrl]="careCtrl"
              [nutritionCtrl]="nutritionCtrl"
              [temperamentCtrl]="temperamentCtrl"
            />
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <p-multiSelect id="handoverHealthStatus" [options]="healthStatusOptions"
                optionLabel="label" optionValue="value" formControlName="handoverHealthStatus"
                [style]="{ width: '100%' }" [panelStyle]="{ width: '100%' }" appendTo="body" />
              <label for="handoverHealthStatus">{{ 'animalAdd.securing.health.status' | transloco }}</label>
            </p-iftalabel>
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <input pInputText type="text" class="w-full" id="handedOverEquipment" formControlName="handedOverEquipment" />
              <label for="handedOverEquipment">{{ 'animalAdd.securing.health.handedOverEquipment' | transloco }}</label>
            </p-iftalabel>
          </div>
          <div class="col-span-12 flex items-center gap-2 mt-2">
            <p-checkbox inputId="needsImmediateVetCare" binary="true" formControlName="needsImmediateVetCare"></p-checkbox>
            <label for="needsImmediateVetCare">{{ 'animalAdd.securing.health.needsImmediateVetCare' | transloco }}</label>
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <textarea pInputText class="w-full" id="healthDescription" rows="5" formControlName="healthDescription"></textarea>
              <label for="healthDescription">{{ 'animalAdd.securing.health.description' | transloco }}</label>
            </p-iftalabel>
          </div>
          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <textarea pInputText class="w-full" id="behaviourAtHandover" rows="5" formControlName="behaviourAtHandover"></textarea>
              <label for="behaviourAtHandover">{{ 'animalAdd.securing.health.behaviour' | transloco }}</label>
            </p-iftalabel>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>

    <!-- Beteiligte Personen (projiziert: app-origin-contacts) -->
    <p-accordion-panel value="6">
      <p-accordion-header>
        <span>{{ 'animalAdd.securing.contacts.headline' | transloco }}</span>
      </p-accordion-header>
      <p-accordion-content>
        <div class="grid grid-cols-12 gap-2">
          <div class="col-span-12 mt-4">
            <div class="flex items-start gap-2">
              <p-checkbox inputId="ownerPresentAtHandover" binary="true" formControlName="ownerPresentAtHandover"></p-checkbox>
              <label for="ownerPresentAtHandover" class="ml-2">{{ 'animalAdd.securing.handover.ownerPresent' | transloco }}</label>
            </div>
          </div>
          <div class="col-span-12">
            <ng-content></ng-content>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>

<!-- Neue Behörde anlegen (wiederverwendeter Dialog) -->
<app-competent-authority-create-dialog
  [(visible)]="createAuthorityDialogVisible"
  (created)="onNewAuthorityCreated($event)"
/>

<!-- Neuen Kontakt für die gewählte Behörde anlegen -->
<p-dialog
  [(visible)]="contactDialogVisible"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '90vw', height: '90vh' }"
  header="{{ 'animalAdd.securing.handover.newContact' | transloco }}"
>
  <ng-template pTemplate="content">
    <div class="p-2">
      <app-choose-contact
        [onlyCreateContact]="true"
        [newContact]="newContactDraft"
        [allowEmptyValid]="true"
        (newContactUpdated)="selectedContact = $event"
        (existingContactSelected)="selectedContact = $event"
      />
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        styleClass="p-button-text"
        [text]="true"
        icon="pi pi-times"
        label="{{ 'modal.cancel' | transloco }}"
        (click)="contactDialogVisible = false"
      />
      <p-button
        icon="pi pi-save"
        label="{{ 'modal.save' | transloco }}"
        [disabled]="!canSaveContact || savingContact"
        (click)="saveNewContact()"
      />
    </div>
  </ng-template>
</p-dialog>
